/* 4AM Pinheiros "Obrigada, SP" page (sections/pinheiros-thanks.liquid).
   A custom element, so theme editor section reloads re-run connectedCallback
   and disconnectedCallback cleans up listeners, timers and observers. */
(function () {
  if (customElements.get('pinheiros-thanks')) return;

  var COPIED_RESET_MS = 1800;
  var TICK_MS = 1000;
  var DAY_S = 86400;
  // Coupon days start and end at midnight in São Paulo.
  var SP_OFFSET = '-03:00';

  var prefersReducedMotion = function () {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };

  class PinheirosThanks extends HTMLElement {
    connectedCallback() {
      this.cleanups = [];
      this.setupCopy();
      this.setupCurtain();
      this.setupLooks();
      this.setupSpots();
      this.setupCountdown();
      this.setupVideos();
      this.setupDrawing();
    }

    disconnectedCallback() {
      (this.cleanups || []).forEach(function (fn) { fn(); });
      this.cleanups = [];
    }

    listen(target, type, handler, options) {
      target.addEventListener(type, handler, options);
      this.cleanups.push(function () { target.removeEventListener(type, handler, options); });
    }

    setupCopy() {
      var button = this.querySelector('[data-p4-copy]');
      var label = this.querySelector('[data-p4-copy-label]');
      var code = this.dataset.coupon;
      if (!button || !label || !code) return;
      var original = label.textContent;
      var timer = 0;
      this.listen(button, 'click', function () {
        var done = function () {
          label.textContent = 'Copiado!';
          clearTimeout(timer);
          timer = setTimeout(function () { label.textContent = original; }, COPIED_RESET_MS);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, function () { label.textContent = code; });
        } else {
          label.textContent = code;
        }
      });
      this.cleanups.push(function () { clearTimeout(timer); });
    }

    setupCurtain() {
      var curtain = this.querySelector('[data-p4-curtain]');
      var copy = this.querySelector('[data-p4-copy]');
      if (!curtain) return;
      // Keep the coupon out of the tab order until the curtain is opened.
      if (copy) copy.inert = true;
      this.listen(curtain, 'click', function () {
        if (copy) copy.inert = false;
        curtain.classList.add('is-open');
        curtain.setAttribute('tabindex', '-1');
        if (copy) copy.focus({ preventScroll: true });
        curtain.setAttribute('aria-hidden', 'true');
      });
    }

    setupLooks() {
      var rail = this.querySelector('[data-p4t-looks]');
      if (!rail) return;
      var behavior = function () { return prefersReducedMotion() ? 'auto' : 'smooth'; };
      var step = function () {
        var look = rail.querySelector('.p4t-look');
        return look ? look.offsetWidth + 20 : 300;
      };
      var prev = this.querySelector('[data-p4t-prev]');
      var next = this.querySelector('[data-p4t-next]');
      if (prev) this.listen(prev, 'click', function () {
        if (rail.scrollLeft <= 4) rail.scrollTo({ left: rail.scrollWidth, behavior: behavior() });
        else rail.scrollBy({ left: -step(), behavior: behavior() });
      });
      if (next) this.listen(next, 'click', function () {
        if (rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 4) rail.scrollTo({ left: 0, behavior: behavior() });
        else rail.scrollBy({ left: step(), behavior: behavior() });
      });
      // Theme editor: selecting a look block scrolls it into view.
      this.listen(document, 'shopify:block:select', function (event) {
        if (!rail.contains(event.target)) return;
        rail.scrollTo({ left: event.target.offsetLeft - rail.offsetLeft, behavior: behavior() });
      });
    }

    setupSpots() {
      var self = this;
      if (!this.querySelector('[data-p4t-spot]')) return;
      var close = function (except) {
        self.querySelectorAll('.p4t-spot.is-open').forEach(function (spot) {
          if (spot === except) return;
          spot.classList.remove('is-open');
          var button = spot.querySelector('[data-p4t-spot]');
          if (button) button.setAttribute('aria-expanded', 'false');
        });
      };
      // One document listener: a tap on a "+" toggles its card, a tap anywhere else closes them all.
      this.listen(document, 'click', function (event) {
        var button = event.target.closest ? event.target.closest('[data-p4t-spot]') : null;
        if (!button || !self.contains(button)) return close(null);
        var spot = button.parentNode;
        var open = !spot.classList.contains('is-open');
        close(spot);
        spot.classList.toggle('is-open', open);
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      this.listen(this, 'keydown', function (event) {
        if (event.key === 'Escape') close(null);
      });
    }

    setupCountdown() {
      var box = this.querySelector('[data-p4t-countdown]');
      if (!box) return;
      var start = Date.parse(box.dataset.start + 'T00:00:00' + SP_OFFSET);
      var end = Date.parse(box.dataset.end + 'T00:00:00' + SP_OFFSET) + DAY_S * 1000;
      if (isNaN(start) || isNaN(end)) return;
      var label = box.querySelector('[data-p4t-cd-label]');
      var cells = {};
      box.querySelectorAll('[data-p4t-cd]').forEach(function (el) { cells[el.dataset.p4tCd] = el; });
      var days = box.querySelectorAll('[data-day]');
      var tick = function () {
        var now = Date.now();
        var target = now;
        var text = 'Acabou. Obrigada!';
        if (now < start) { target = start; text = 'Começa em'; }
        else if (now < end) { target = end; text = 'Acaba em'; }
        var left = Math.max(0, Math.floor((target - now) / 1000));
        if (cells.d) cells.d.textContent = pad(Math.floor(left / DAY_S));
        if (cells.h) cells.h.textContent = pad(Math.floor((left % DAY_S) / 3600));
        if (cells.m) cells.m.textContent = pad(Math.floor((left % 3600) / 60));
        if (cells.s) cells.s.textContent = pad(left % 60);
        if (label) label.textContent = text;
        var today = '';
        try { today = new Date(now).toLocaleDateString('en-CA', { timeZone: 'America/Sao_Paulo' }); } catch (e) { today = ''; }
        days.forEach(function (day) { day.classList.toggle('is-today', day.dataset.day === today); });
      };
      tick();
      var timer = setInterval(tick, TICK_MS);
      this.cleanups.push(function () { clearInterval(timer); });
    }

    setupVideos() {
      var videos = this.querySelectorAll('[data-p4-video]');
      if (!videos.length || prefersReducedMotion()) return;
      var play = function (video) {
        var promise = video.play();
        if (promise && promise.catch) promise.catch(function () {});
      };
      if (!('IntersectionObserver' in window)) {
        videos.forEach(play);
        return;
      }
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) play(entry.target);
          else entry.target.pause();
        });
      }, { rootMargin: '200px' });
      videos.forEach(function (video) { observer.observe(video); });
      this.cleanups.push(function () { observer.disconnect(); });
    }

    setupDrawing() {
      if (!('IntersectionObserver' in window) || prefersReducedMotion()) return;
      var self = this;
      var targets = this.querySelectorAll('.p4-draw, .p4-lbx');
      if (!targets.length) return;
      this.classList.add('p4--draw');
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-on');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.4 });
      targets.forEach(function (el) { observer.observe(el); });
      this.cleanups.push(function () {
        observer.disconnect();
        self.classList.remove('p4--draw');
      });
    }
  }

  customElements.define('pinheiros-thanks', PinheirosThanks);
})();
